<app-document-subheader />

<div class="page-container">
  <div class="card card-light w-100">
    <div class="card-body">
      <div class="container-fluid">
        <app-work-schedule-form-content />
      </div>
    </div>
  </div>
</div>
